export function createSidebarList() {
  const articleTitles = document.querySelectorAll('[id^="ems-title-"]');
  //const articleTitles = document.querySelectorAll(".wp-block-heading ");
  const sidebarList = document.querySelector(".sidebar__list");

  if (!(articleTitles && sidebarList)) return;

  articleTitles.forEach((title, index) => {
    const listItem = document.createElement("li");
    listItem.classList.add("sidebar__item");

    const link = document.createElement("a");
    link.classList.add("sidebar__link");
    link.href = `#title-${index + 1}`;
    link.textContent = title.textContent;

    title.id = `title-${index + 1}`;
    listItem.appendChild(link);
    sidebarList.appendChild(listItem);
  });
}

export function initSidebarDropdown() {
  const toggleBtn = document.querySelector(".sidebar__title-box");
  const sidebar = document.querySelector(".sidebar__top");
  const dropdownArrow = document.querySelector(".sidebar__dropdawn-icon");

  if (!(toggleBtn && sidebar)) return;

  toggleBtn.addEventListener("click", function (event) {
    if (window.innerWidth <= 1280) {
      sidebar.classList.toggle("active");
      dropdownArrow.classList.toggle("show");
    }
  });
}
